export const getMembersBaseUrl = (pathname: string): string => {
  const baseURL = process.env.NEXT_PUBLIC_MEMBERS_BACKEND_URL;

  const productIdRegex = /\/([^/]+)\/([^/]+)/;
  const matches = pathname.match(productIdRegex);

  if (matches) {
    const [fullMatch, products, productID] = matches;
    const membersBaseUrl = `${baseURL}/courses/`;
    return membersBaseUrl.concat(productID);
  } else {
    return "";
  }
};
